import { get, patch } from 'core_main/request';
import { updateStore } from 'core_main/store';

import {
  CUSTOMERS_CURRENT_ENDPOINT,
  CURRENT_CUSTOMERS_CONTEXT_ENDPOINT,
} from './constants';
import {
  convertCurrentCustomerContextResponseToCustomerDetails,
  validateUpdateCurrentCustomerParams,
} from './helpers';
import { UpdateCurrentCustomerParameters } from './types';

export const updateCurrentCustomer = (
  parameters: UpdateCurrentCustomerParameters,
) => {
  const { attributes, custom } = parameters;

  const validationError = validateUpdateCurrentCustomerParams(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return patch(CUSTOMERS_CURRENT_ENDPOINT, {
    body: JSON.stringify({ ...attributes, custom }),
  });
};

export const getCurrentCustomerContext = () => {
  return get(CURRENT_CUSTOMERS_CONTEXT_ENDPOINT).then((response) => {
    updateStore(
      'customerContext',
      convertCurrentCustomerContextResponseToCustomerDetails(response),
    );
    return response;
  });
};
